import React, { Component } from 'react';
import './editalumni.css';
import { Input, Modal, message, Button, Tabs, Row, Spin, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Checkbox } from 'antd';
import moment from 'moment';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask'

const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const Panel = Collapse.Panel;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const customPanelStyle = {
    background: '#fff',
    borderRadius: 4,
    marginBottom: 24,
    border: 0,
    overflow: 'hidden',
};


class SummaryForm extends Component {

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log(values)
                this.props.actions.updateProfile()
            }
        });
    }

    renderSummaryForm = (profileinfo) => {
        const Option = Select.Option;
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const selectBefore = (
            <Select defaultValue="Prefix" className="dropdown-blue" >
                <Option value="mr">Mr</Option>
                <Option value="mrs">Mrs</Option>
            </Select>
        );
        const selectAfter = (
            <Select defaultValue="Suffix" className="dropdown-blue">
                <Option value="mr">Mr</Option>
                <Option value="mrs">Mrs</Option>
            </Select>
        );
        const selectBeforeMobile = (
            <Select defaultValue="Mobile" className="dropdown-blue" >
                <Option value="999">999</Option>
                <Option value="+999">+999</Option>
            </Select>
        );

        const dateFormat = 'MM/DD/YYYY';
        return (
            <div>
                <Spin spinning={false}>
                    <Form onSubmit={this.handleSubmit} layout="vertical" className="">
                        {/* Constituent Information */}
                        <Collapse defaultActiveKey={'1'} accordion style={{ border: 'none', backgroundColor: 'inherit' }}>
                            <Panel header="Constituent Personal Information" key="1" style={customPanelStyle}>

                                <Row type="flex" justify="space-between">
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="First Name"
                                        >
                                            <Input addonBefore={selectBefore} placeholder="First Name" value={profileinfo.profile.firstName} />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Middle Name"
                                        >
                                            <Input placeholder="Middle Name" value={profileinfo.profile.middleName} />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Last Name"
                                        >
                                            <Input addonAfter={selectAfter} placeholder="Last Name" value={profileinfo.profile.lastName} />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Nick Name:"
                                        >
                                            {getFieldDecorator('nickName', { initialValue: profileinfo.profile.nickName, rules: [{ required: true, message: 'Required!', }], })(
                                                <Input addonAfter={selectAfter} placeholder="Nick Name" />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Maiden Name:"
                                        >
                                            <Input placeholder="Maiden Name" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Date Of Birth:"
                                        >
                                            {/* <DatePicker placeholder="MM/DD/YYYY" format={dateFormat} style={{ width: "100%" }} /> */}
                                            <InputMask
                                                    mask="99/99/9999"
                                                    placeholder='MM/DD/YYYY'
                                                    alwaysShowMask
                                                    maskChar={null}
                                                    className="ant-input width-100"
                                                    render={(ref, props) => (
                                                        <Input  />
                                                    )}
                                                />

                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Gender:"
                                        // {...formItemLayout}
                                        >
                                            <Select
                                                showSearch
                                                // style={{ width: 200 }}
                                                placeholder="Select a Gender"
                                            // optionFilterProp="children"
                                            // onChange={handleChange}
                                            // onFocus={handleFocus}
                                            // onBlur={handleBlur}
                                            // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                <Option value="male">Male</Option>
                                                <Option value="female">Female</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="  "
                                        >
                                            <Checkbox.Group style={{ width: '100%' }}
                                            // onChange={onChange}
                                            >
                                                <Row type='flex' justify='space-between'>
                                                    <Col xs={11} sm={11} md={11} lg={11} xl={11}><Checkbox value="A">Deceased</Checkbox></Col>
                                                    <Col xs={11} sm={11} md={11} lg={11} xl={11}><Checkbox value="B">Archived</Checkbox></Col>
                                                </Row>
                                            </Checkbox.Group>
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                    </Col>
                                </Row>
                                <Row type="flex" justify="space-between">
                                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                        <Row type='flex' align='middle'>
                                            <FormItem>
                                                <label className='field-label'> MEMBER ID </label>
                                                <label className='my-profile-field-value'> {profileinfo.profile.memberId} </label>
                                            </FormItem>
                                        </Row>
                                    </Col>
                                </Row>

                                <hr className="line-divider" />
                                <Row type='flex' justify='space-around'>
                                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                        <FormItem className='margin-bottom-0'>
                                            <Button className="myprofile-cancel-btn" >CANCEL</Button>
                                        </FormItem>
                                    </Col>
                                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                        <FormItem className='margin-bottom-0'>
                                            <Button className="margin-bottom-0 save-change-btn" htmlType="submit" type="primary">SAVE CHANGES</Button>
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Panel>
                        </Collapse>

                        {/* Constituent Contact */}
                        <Collapse defaultActiveKey={'1'} accordion style={{ border: 'none', backgroundColor: 'inherit' }}>
                            <Panel header="Constituent Primary Contact Information" key="1" style={customPanelStyle}>

                                <Row type="flex" justify="space-around">
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Phone"
                                        >
                                            <Input addonBefore={selectBeforeMobile} placeholder="(999) 999-9999" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Email:"
                                        >
                                            <Input placeholder="Email Address" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}></Col>
                                </Row>

                                <hr className="line-divider" />
                                <Row type='flex' justify='space-around'>
                                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                        <FormItem className='margin-bottom-0'>
                                            <Button className="myprofile-cancel-btn" >CANCEL</Button>
                                        </FormItem>
                                    </Col>
                                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                        <FormItem className='margin-bottom-0'>
                                            <Button className="margin-bottom-0 save-change-btn" htmlType="submit" type="primary">SAVE CHANGES</Button>
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Panel>
                        </Collapse>

                        {/* Constituent Address */}
                        <Collapse defaultActiveKey={'1'} accordion style={{ border: 'none', backgroundColor: 'inherit' }}>
                            <Panel header="Constituent Primary Address Information" key="1" style={customPanelStyle}>
                                <Row type="flex" justify="space-between">
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Address Line 1:"
                                        >
                                            <Input placeholder="Address Line 1" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Address Line 2:"
                                        >
                                            <Input placeholder="Address Line 2" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Address Type:"
                                        // {...formItemLayout}
                                        >
                                            <Select
                                                showSearch
                                                // style={{ width: 200 }}
                                                placeholder="Select Address Type"
                                            // optionFilterProp="children"
                                            // onChange={handleChange}
                                            // onFocus={handleFocus}
                                            // onBlur={handleBlur}
                                            // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                <Option value="home">Home</Option>
                                                <Option value="hotel">Hotel</Option>
                                                <Option value="hostel">Hostel</Option>
                                                <Option value="others">Others</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="City:"
                                        >
                                            <Input placeholder="City" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="State:"
                                        // {...formItemLayout}
                                        >
                                            <Select
                                                showSearch
                                                // style={{ width: 200 }}
                                                placeholder="Select State"
                                            // optionFilterProp="children"
                                            // onChange={handleChange}
                                            // onFocus={handleFocus}
                                            // onBlur={handleBlur}
                                            // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                <Option value="home">Home</Option>
                                                <Option value="hotel">Hotel</Option>
                                                <Option value="hostel">Hostel</Option>
                                                <Option value="others">Others</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="ZIP Code:"
                                        >
                                            <Input placeholder="ZIP Code" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Province:"
                                        >
                                            <Input placeholder="Province" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Country:"
                                        // {...formItemLayout}
                                        >
                                            <Select
                                                showSearch
                                                // style={{ width: 200 }}
                                                placeholder="Select Country"
                                            // optionFilterProp="children"
                                            // onChange={handleChange}
                                            // onFocus={handleFocus}
                                            // onBlur={handleBlur}
                                            // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                <Option value="home">Home</Option>
                                                <Option value="hotel">Hotel</Option>
                                                <Option value="hostel">Hostel</Option>
                                                <Option value="others">Others</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="  "
                                        >
                                            <Checkbox.Group style={{ width: '100%' }}
                                            // onChange={onChange}
                                            >
                                                <Row type='flex' justify='space-between'>
                                                    <Col xs={22} sm={22} md={24} lg={24} xl={24}><Checkbox value="A">primary</Checkbox></Col>
                                                </Row>
                                            </Checkbox.Group>
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Mail Preferences:"
                                        // {...formItemLayout}
                                        >
                                            <Select
                                                showSearch
                                                // style={{ width: 200 }}
                                                placeholder="Mail Preferences"
                                            // optionFilterProp="children"
                                            // onChange={handleChange}
                                            // onFocus={handleFocus}
                                            // onBlur={handleBlur}
                                            // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                <Option value="yes">Yes</Option>
                                                <Option value="no">No</Option>
                                            </Select>
                                        </FormItem>
                                    </Col>
                                </Row>

                                <hr className="line-divider" />
                                <Row type='flex' justify='space-around'>
                                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                        <FormItem className='margin-bottom-0'>
                                            <Button className="myprofile-cancel-btn" >CANCEL</Button>
                                        </FormItem>
                                    </Col>
                                    <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                        <FormItem className='margin-bottom-0'>
                                            <Button className="margin-bottom-0 save-change-btn" htmlType="submit" type="primary">SAVE CHANGES</Button>
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Panel>
                        </Collapse>



                    </Form>
                </Spin>
            </div>
        );
    }

    render() {
        if (this.props.updateprofilestatus == "Successfully Updated") {
            Modal.success({
                title: 'Success',
                content: 'Profile updated Successfully!',
            });
        }
        if (this.props.profileinfo) {
            return (
                <div>
                    {this.renderSummaryForm(this.props.profileinfo)}
                </div>
            );
        }
        return (
            <div>
                return <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Profile Summary..." />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        profileinfo: state.alumniinforeducer.profileinfo,
        updateprofileloading: state.updateprofilereducer.loading,
        updateprofilestatus: state.updateprofilereducer.status
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

const Summary = Form.create()(SummaryForm);

export default connect(mapStateToProps, mapDispatchToProps)(Summary);


// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/Summary.js